import React from 'react';
import { Separator } from '@/Components/shadcn';
import { cn } from '@/lib/utils';

export function VerticalDivider({ className, ...props }: React.ComponentProps<'div'>): React.JSX.Element {
    return <Separator orientation="vertical" className={cn('bg-border mx-2 my-0', className)} {...props} />;
}

export function HorizontalDivider({ className, ...props }: React.ComponentProps<'div'>): React.JSX.Element {
    return <Separator orientation="horizontal" className={cn('bg-border', className)} {...props} />;
}
